import React from "react";
import GitHubCalendar from "react-github-calendar";
import { Image, Row } from "react-bootstrap";


function Github() {
  return (
    <>
      <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
        <h2 className="section__title" data-aos="fade-right">
          Git  <span className="different">Calender 🖥️</span>
        </h2>
        <GitHubCalendar
          username="jubershaikh2307"
          blockSize={15}
          blockMargin={10}
          color="green"
          fontSize={18}
        />
      </Row>
      <Row style={{ justifyContent: "center", paddingBottom: "10px"}}>
        <Image src="https://github-readme-stats.vercel.app/api?username=Jubershaikh2307&show_icons=true&locale=en&theme=react&hide_border=true&bg_color=0D1117"/>
      </Row>

      <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
        <Image src="https://github-readme-streak-stats.herokuapp.com/?user=Jubershaikh2307&hide_border=true&theme=react&hide_border=true&bg_color=0D1117"/>
      </Row>


    </>


  );
}

export default Github;

